import {Popover, PopoverProps} from "@mui/material";

type PartnerSwitcherPopoverProps = PopoverProps;

export function PartnerSwitcherPopover({
  children,
  slotProps,
  ...props
}: PartnerSwitcherPopoverProps) {
  return (
    <Popover
      anchorOrigin={{
        vertical: "center",
        horizontal: "right",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
      slotProps={{
        paper: {
          sx: {
            borderRadius: 3,
            boxShadow: 3,
            minWidth: 240,
          },
          ...slotProps?.paper,
        },
      }}
      {...props}
    >
      {children}
    </Popover>
  );
}
